import { SiteHeader, SiteFooter } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";
import SiteSections from "./SiteSections";

export default function SiteHome() {
  const site = useSiteContent();
  usePageMeta("Event Medical Cover UK | Wales Event Medical Services",
    "Professional medical cover for events across the UK — first responders to doctors, ambulances and treatment units for festivals, sports, corporate and community events. Get a free quote.", "", "home");
  return (
    <div className="overflow-hidden site-font bg-[#0B0F14]" data-testid="site-home">
      <SiteHeader />
      <SiteSections sections={site.page_sections.home} services={site.services_catalog} contact={site.contact_info} />
      <SiteFooter />
    </div>
  );
}
